import safeFetch from '../../utils/safeFetch';

const getShopRegionsFromUrl = (url) => {
  return new Promise((resolve, reject) => {
    safeFetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => reject(error));
  });
};

export default getShopRegionsFromUrl;
